import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ajaxCall } from 'src/app/core/services/ajax-call.service';
import { VendorNoteInformation } from '../models/vendor-note-information.model';

@Component({
  selector: 'app-vendor-note',
  templateUrl: './vendor-note.component.html',
  styles: [
  ]
})
export class VendorNoteComponent implements OnInit {
  @ViewChild(NgForm) noteForm!: NgForm;

  @Input() noteInfo: VendorNoteInformation;
  submitAttempt: boolean = false;

  constructor(private ajax: ajaxCall,
    private modal: NgbActiveModal) { }

  ngOnInit(): void {
  }

  save(): void {
    this.submitAttempt = true;
    if (this.noteForm.invalid) {
      return;
    }
    this.ajax.MakeCall('/Vendor/SaveNote', this.noteInfo).then(() => {
      this.modal.close();
    }, () => { });
  }

  dismiss(): void {
    this.modal.dismiss();
  }
}
